import { useEffect, useRef } from "react";

/**
 * 화면 전환·상태 화면 표시 때 제목(또는 배너)으로 포커스를 옮긴다 — 키보드·스크린 리더 사용자가
 * 새 화면의 시작점을 잃지 않게(SR-NFR-06). 대상에는 tabIndex={-1} 을 준다.
 */
export function useFocusOnMount<T extends HTMLElement>(dep?: unknown) {
  const ref = useRef<T>(null);
  useEffect(() => {
    ref.current?.focus({ preventScroll: false });
  }, [dep]);
  return ref;
}
